export default {
  pid: 'Publication ID',
  username: 'User Name',
  posted_at: 'Original Document Date',
  processed_at: 'Import Date',
  post_url: 'Publication URL',
  openPostLabel: 'Open publication',
  infoLabel: 'Component Information',
  closeLabel: 'Close information',
  faq1: {
    title: 'What is it?',
    description: 'Component with import history data',
  },
  faq2: {
    title: 'What data is available?',
    description: 'User who imported, document date, import date, and document link',
  },
  unavailableLink: 'Link unavailable',
  textToClipboard: 'Text copied to clipboard.',
  failedClipboard: 'Failed to copy text.',
};
